<template>
    <ul class="quiz-list">
        <li
            v-for="(question, questionIndex) in questions"
            :key="question._id"
            class="quiz-question"
        >
            <h4 class="color-dark" :data-test-id="`quiz-question-${questionIndex}-name`">
                <strong>{{ question.name || question.title }}</strong>
            </h4>
            <span
                v-show="question.description"
                class="quiz-question-description"
                :data-test-id="`quiz-question-${questionIndex}-description`"
            >
                {{ question.description }}
            </span>
            <hr />

            <!-- Error -->
            <div
                v-show="incorrectAnswers.includes(question._id)"
                data-test-id="incorrect-answer-error"
            >
                <p class="color-red">{{ $t("learning.progress.todo.error.answer") }}</p>
                <hr />
            </div>
            <!--/Error -->

            <ul class="quiz-question-options-list">
                <li v-for="(option, optionIndex) in question.options" :key="option._id">
                    <label
                        class="quiz-question-option color-dark clickable"
                        :for="`option-correct-${option._id}-check`"
                    >
                        <input
                            :id="`option-correct-${option._id}-check`"
                            v-model="option.correct"
                            type="checkbox"
                            :data-test-id="`quiz-question-${questionIndex}-option-${optionIndex}`"
                            @click="
                                e => {
                                    if (optionSelectDisabled || !toggleCorrectOption) {
                                        e.preventDefault();
                                    } else {
                                        toggleCorrectOption(questionIndex, optionIndex);

                                        // ... because reactivity is hard :(
                                        $forceUpdate();
                                    }
                                }
                            "
                        />
                        {{ option.title }}
                    </label>
                </li>
            </ul>
            <hr />
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        questions: {
            type: Array,
            required: true,
        },
        toggleCorrectOption: {
            type: Function,
            default: null,
        },
        optionSelectDisabled: {
            type: Boolean,
            default: false,
        },
        incorrectAnswers: {
            type: Array,
            default: () => [],
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped>
.quiz-list,
.quiz-question-options-list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.quiz-list li,
.quiz-question-options-list li {
    padding: 0;
    margin: 0;
}

.quiz-question {
    margin-bottom: 15px;
    margin-left: 10px;
    padding-top: 15px;
}
.quiz-question:first-of-type {
    border-top: none;
}

.quiz-question-title {
    display: block;
    margin-top: 12px;
    margin-bottom: 12px;
}
.quiz-question-description {
    display: block;
    margin-top: -4px;
    font-size: 16px;
    color: var(--color-grey);
}

.quiz-question-option {
    display: block;
    padding: 12px;
    border: 1px solid var(--color-grey-light);
    border-radius: 6px;
    margin-bottom: 12px;
    transition: background-color 100ms ease-in-out;
}
.quiz-question-option input[type="checkbox"] {
    margin: 0px;
    margin-right: 8px;
}
.quiz-question-option:hover {
    background-color: var(--color-grey-light);
}
</style>
